export default "__VITE_ASSET__TDERgRIZ__"